import {
    doesNotHaveExpand,
    get,
} from "@insite/client-framework/Services/ApiService";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { OrderCollectionModel, OrderModel } from "@insite/client-framework/Types/ApiModels";

const ordersUrl = "/api/v1/orders";

// Created this custom service to add Order Id is custom properties 
export async function getOrdersCustom(parameter: GetOrdersApiParameter): Promise<OrderCollectionModel> {
    // can't send empty status array to API
    if (parameter.status && parameter.status.length === 0) {
        delete parameter.status;
    }

    delete (parameter as any).onComplete;
    const orders = await get<OrderCollectionModel>(ordersUrl, parameter);
    orders.orders?.forEach(o => {
        cleanOrder(o);
    });
    return orders;
}

function cleanOrder(orderModel: OrderModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    orderModel.orderDate = new Date(orderModel.orderDate);
    // added order ID inside the properties as custom property
    orderModel.properties.orderId = orderModel.id;
    orderModel.id = cleanOrderFieldNewLine(orderModel.erpOrderNumber) || orderModel.webOrderNumber;
    if (doesNotHaveExpand(parameter, "orderLines")) {
        delete orderModel.orderLines;
    }

    if (!orderModel.shipViaDescription) {
        delete orderModel.shipViaDescription;
    }
}

function cleanOrderFieldNewLine(field: string) {
    // \r\n = CR + LF → Used as a new line character in Windows
    // \r = CR (Carriage Return) → Used as a new line character in Mac OS before X
    // \n = LF (Line Feed) → Used as a new line character in Unix/Mac OS X
    return field.trim().replace(/\r\n/gi, "").replace(/\r/gi, "").replace(/\n/gi, "");
}